const noop = () => {};

function loadJS(src, scriptId) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.id = scriptId;
    document.head.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
  });
}

export function makeAsyncScriptLoader(urls, scriptId) {
  return (onReady = noop) => {
    const existingScript = document.getElementById(scriptId);
    if (existingScript) return onReady();

    Promise.all(urls.map(url => loadJS(url, scriptId))).then(() => {
      onReady();
    });
  };
}



// WEBPACK FOOTER //
// ./src/utils/load-script-async.js